import Typography from '#components/typography/Typography';
import PageSection, {
  PageSectionProps,
} from '#components/sections/page-section/PageSection';

type Props = {
  title?: string;
  image?: string;
  content?: string | JSX.Element;
  direction?: 'LTR' | 'RTL';
  classes?: string;
  verticalAlignContent?: 'center' | 'top';
  pageSectionProps?: Omit<PageSectionProps, 'children'>;
};

const IllustratedLayout = ({
  title,
  image,
  content,
  direction = 'LTR',
  classes,
  verticalAlignContent,
  pageSectionProps,
}: Props) => {
  return (
    <PageSection {...pageSectionProps}>
      <div
        className={`container mx-auto tw-items-center tw-pt-24 ${
          classes ? classes : ''
        }`}
      >
        <div className="tw-grid tw-mx-auto medium-up:tw-grid-cols-2 large-up:tw-w-3/4">
          <div
            className={`tw-px-4 tw-text-center ${
              direction === 'LTR'
                ? 'medium-up:tw-order-1'
                : 'medium-up:tw-order-2'
            }`}
          >
            <img
              className="tw-shrink-0 tw-inline-block"
              src={image}
              alt={title}
            />
          </div>
          <div
            className={`tw-px-4 tw-flex tw-flex-col ${
              direction === 'LTR' ? 'tw-order-2' : 'tw-order-1'
            } ${
              verticalAlignContent === 'center'
                ? 'medium-up:tw-justify-center'
                : ''
            }`}
          >
            {title && (
              <Typography
                element="h2"
                effect="gradient"
                color="secondary"
                classes="medium-up:tw-mb-16 tw-text-title-s large-up:tw-text-title-m"
              >
                {title}
              </Typography>
            )}
            {typeof content !== 'string' && content}
            {typeof content === 'string' && (
              <Typography classes="tw-mb-16 large-up:tw-mb-32">
                {content}
              </Typography>
            )}
          </div>
        </div>
      </div>
    </PageSection>
  );
};
export default IllustratedLayout;
